// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
const { pluralize } = require('shared/string-utils')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const useInfiniteScroll = require('client-v2/common/hooks/infinite-scroll')
// Container imports
const ArticleProfileCollectionsItem = require('./collections-item')
const { ArticleAddCircleButton } = require('client-v2/common/components/buttons')

// String helpers
const collections = pluralize('Collection')

// BEM Block entity definition
const bem = BemEntity('ArticleProfileCollectionsV2')

function ArticleProfileCollections(props) {
  return (
    tag('section', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag(Header, props),
      (props.items.length || props.isMoreLoading)
      ? tag(CollectionsList, props)
      : tag(EmptyMessage, props)
    )
  )
}

ArticleProfileCollections.propTypes = {
  // Flags
  isMoreAvailable: PropTypes.bool,
  isMoreLoading: PropTypes.bool,
  // Values
  article: PropTypes.object.isRequired,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  // Callbacks
  onAddClick: PropTypes.func.isRequired,
  onCollectionNavigate: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func,
  onUserNavigate: PropTypes.func.isRequired
}

module.exports = ArticleProfileCollections

// BEM Block entity Element components

function Header(props) {
  const { article: { count } } = props
  return (
    tag('div', {
      className: bem.element('header')
    },
      tag('div', {
        className: bem.element('header-content')
      },
        props.isMoreLoading && !props.items.length
        ? tag([ 'Loading collections...' ])
        : tag([
          'In ',
          tag('span', {
            className: bem.element('header-count')
          },
            count.toLocaleString()
          ),
          ` ${collections(count)}`
        ])
      )
    )
  )
}

function CollectionsList(props) {
  const showLoadingIndicator = props.isMoreLoading || props.isMoreAvailable
  const scrollableRef = useInfiniteScroll({
    onLoadMore: props.onLoadMore
  })
  return (
    tag('div', {
      ref: scrollableRef,
      className: bem.element('list')
    },
      props.items.map(item => (
        tag(ArticleProfileCollectionsItem, {
          key: `${item.user.id}`,
          className: bem.element('list-item'),
          item,
          onCollectionNavigate: props.onCollectionNavigate,
          onUserNavigate: props.onUserNavigate
        })
      )),
      showLoadingIndicator && tag('div', {
        className: bem.element('loading-indicator', {
          pending: props.isMoreLoading
        })
      })
    )
  )
}

function EmptyMessage(props) {
  const { article } = props
  return (
    tag('div', {
      className: bem.element('empty-content')
    },
      tag('div', {
        className: bem.element('empty-heading')
      },
        'Want to save this for later?'
      ),
      tag('div', {
        className: bem.element('empty-message')
      },
        'Add this to a collection that you can view later, or share with friends.'
      ),
      tag('div', {
        className: bem.element('empty-call-to-action')
      },
        tag(ArticleAddCircleButton, {
          checked: false,
          onClick: () => props.onAddClick({ article })
        }),
        'Be the first to collect this post'
      )
    )
  )
}
